import React from 'react';
import { Link } from 'react-router-dom';
import { Calculator } from 'lucide-react';
import DisclaimerBox from '../components/DisclaimerBox';
import { FAQS } from '../mock/mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

export default function FAQ() {
  return (
    <div className="bg-alp-black min-h-screen">
      <div className="border-b border-alp-line">
        <div className="max-w-4xl mx-auto px-5 md:px-8 py-16 text-center">
          <p className="text-alp-gold text-xs tracking-[0.3em] uppercase mb-3">Questions</p>
          <h1 className="font-serif text-5xl md:text-6xl text-alp-cream heading-glow">Frequently Asked Questions</h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-16">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-alp-line">
              <AccordionTrigger className="text-alp-cream hover:text-alp-gold text-left font-serif text-xl">{f.q}</AccordionTrigger>
              <AccordionContent className="text-alp-gray leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-10 flex justify-center">
          <Link to="/calculator" className="inline-flex items-center gap-2 border border-alp-gold/50 text-alp-cream px-7 py-3.5 text-xs tracking-[0.2em] uppercase hover:border-alp-gold hover:text-alp-gold transition-colors">
            <Calculator size={15} /> Reconstitution Calculator
          </Link>
        </div>
        <div className="mt-12"><DisclaimerBox /></div>
      </div>
    </div>
  );
}
